var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#BF93E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0035 62.9995C31.697 62.9995 32.407 62.9955 33.1325 62.9955H46.866C47.5905 62.9955 48.3005 62.9995 48.994 62.9995C55.3485 62.9995 60.204 62.6745 60.204 56.0315C60.204 49.0785 54.8865 43.3705 48.0955 42.75C48.0415 45.1825 40.0015 51.1855 40.0015 51.1855C40.0015 51.1855 31.9595 45.183 31.905 42.7505C25.115 43.3705 19.7965 49.0785 19.7965 56.0315C19.7965 62.6745 24.65 62.9995 31.0035 62.9995ZM46 53.928C46 53.73 46.1785 53.5705 46.4005 53.5705H48.5725V51.3995C48.5725 51.1795 48.731 50.999 48.929 50.999H51.0725C51.2695 50.999 51.429 51.178 51.429 51.3995V53.571H53.6C53.82 53.571 54 53.7305 54 53.9285V56.071C54 56.269 53.8215 56.4285 53.6 56.4285H51.4285V58.5995C51.4285 58.8205 51.2685 58.9995 51.071 58.9995H48.9285C48.7305 58.9995 48.571 58.821 48.571 58.5995V56.428H46.4C46.179 56.428 45.9995 56.2685 45.9995 56.0705L46 53.928Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.004 44.496C46.146 44.496 51.1245 35.2605 51.1245 29.119C51.1245 22.9785 46.146 18 40.004 18C33.863 18 28.8845 22.9785 28.8845 29.119C28.8845 35.2605 33.863 44.496 40.004 44.496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work2.f88dfddbbaac84f93e4e5363dd890b4b.svg";
export { ForwardRef as ReactComponent };